(function () {
	function SutBatteryController($scope, $element, $attrs) {
		var ctrl = this;

		ctrl.getTemplatePath = function () {
			const template_base = 'partials/device/SutMessages/Battery';
			const template = ctrl.device.features.useBatteryIcon() || ctrl.device.features.useBatteryStateIcon()
						? '/battery_icon.html' : '/battery_text.html';

			return template_base+template;
		}

		ctrl.getBatteryPercentage = function() {
			if (ctrl.message.hasCapacityPercentage())
				return ctrl.message.getBatteryPercentage("%");
			
			if (ctrl.message.hasInitialBatteryPercentage())
				return ctrl.message.getInitialBatteryPercentage("%");

			if (ctrl.prevMessage)
				return ctrl.prevMessage.getBatteryPercentage("%");

			return '-';
		}

		/**
		 * @param {Device} device
		 * @param {SutMessage} message
		 */
		ctrl.determineBatteryIcon = function () {
			if (!ctrl.device.features.isRock()) {
				// Rocks cannot be charged.
				if (ctrl.message.isCharging())
					return "charge";

				if (ctrl.message.isChargerConnected())
					return "power-connected";

				if (ctrl.message.isChargeCompleted()) {
					return "battery";
				}
			}

			// TODO: Figure out how to use this
			if (ctrl.device.hasBatteryStateIndicator())
				return "capacityState";

			if (ctrl.message.hasCapacityBatValues() && (ctrl.device.features.isRock() || !ctrl.message.isCharging()))
				return "battery";

			return false;
		};

		ctrl.getBatteryIcon = function () {
			var icon = undefined;

			if (ctrl.device.isBatteryHigh(ctrl.message)) {
				icon = "battery-high";
			} else if (ctrl.device.isBatteryMedium(ctrl.message)) {
				icon = "battery-medium";
			} else if (ctrl.device.isBatteryLow(ctrl.message)) {
				icon = "battery-low";
			}

			return "assets/images/state/" + icon + ".png";
		};

		ctrl.getBatteryIconText = function() {
			if (ctrl.message.isChargeCompleted()) {
				return 'STR_BATTERY_CAP_CHARGE_COMPLETE'
			}

			return ctrl.message.getBatteryCapacity() ? 'STR_BATTERY_CAP' : 'STR_BATTERY_CAP_UNAVAILABLE'
		}
	}

	SutBatteryController.$inject = ['$scope', '$element', '$attrs'];

	angular
		.module('trackeye')
		.component('sutBattery', {
			template: "<div ng-include='$ctrl.getTemplatePath()'></div>",
			controller: SutBatteryController,
			bindings: {
				prevMessage: '<',
				message: '<',
				device: '<'
			}
		});
})();
